<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            ข่าวสาร
          </v-card-title>
          <v-card-text>
            <v-form ref="news_add_pos_save" @submit.prevent="save_data">

              <v-row>

                <v-col cols="12">
                  <v-text-field prepend-inner-icon="mdi-bookmark-minus" color="#86bc3a" type="text" label="พาดหัวข่าว"
                    v-model="news_title" hide-details="auto" :rules="[rules.is_empty]" outlined></v-text-field>
                </v-col>

                <v-col cols="12">
                  <quillEditor ref="myQuillEditor" v-model="content" />
                  <p v-if="content_validate"
                    style="color: #F28080; font-size: 12px; margin-left: 10px; padding-top: 5px;">ต้องระบุข้อมูลในช่องนี้
                  </p>
                </v-col>

              </v-row>

              <v-row>
                <v-col cols="12 pb-0">
                  <label for="" class="font-18">ระยะเวลาการเผยแพร่ข่าวสาร</label>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0">
                  <v-menu ref="menu_date_start" v-model="menu_date_start" :close-on-content-click="false"
                    :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" clearable class="input_width" v-model="save_news.date_start"
                        label="วันที่เริ่มต้นข่าวสาร" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                        :rules="[rules.is_empty]" outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH_start(temp_date)" v-model="temp_date"
                      :min="date_now" no-title scrollable @input="menu_start = false">
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="pb-0">
                  <v-menu ref="menu_date_end" v-model="menu_date_end" :close-on-content-click="false"
                    :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" clearable class="input_width" v-model="save_news.date_end"
                        label="วันที่สิ้นสุดข่าวสาร" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                        :rules="[rules.is_empty]" outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH_end(temp_date)" v-model="temp_date"
                      :min="save_news.date_start != null ? save_news.date_start : date_now" no-title scrollable
                      @input="menu_end = false">
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12 pb-0">
                  <label for=""> สาขาที่ต้องการแจ้งข่าวสาร </label>
                </v-col>

                <v-col cols="12 pb-0">
                  <v-radio-group v-model="title_type" class="mt-0">
                    <div class="d-flex">
                      <div class="d-flex mr-1">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>ทุกสาขา</div>
                      </div>
                      <div class="d-flex ml-6">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>เลือกสาขาที่ต้องการ</div>
                      </div>
                    </div>
                  </v-radio-group>
                </v-col>

                <v-col v-if="title_type == 1" cols="12 pt-0">
                  <v-autocomplete v-model="values_select" :items="values_items" item-value="customer_code"
                    item-text='store_name' label="เลือกสาขาที่ต้องการแจ้ง" chips clearable deletable-chips filled multiple
                    :rules="[rules.is_empty]" solo></v-autocomplete>
                </v-col>

              </v-row>

              <div class="text-center pt-6">
                <v-btn :disabled="is_submit" large class="white--text grad-success-bg mobile_btn" style="font-size: 18px"
                  type="submit">บันทึก</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
// import {HTTP} from "@/axios";
import { HTTP_ARIN } from "@/axios_arin";
import { quillEditor } from 'vue-quill-editor'
import { formatPrice, onlyForCurrency } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "News_add",
  components: {
    quillEditor
  },
  data() {
    return {
      is_submit: false,
      loading_page: false,
      loading_data: false,
      overlay: false,
      alert_success: false,
      alert_tracking: false,
      news_title: "",
      title_type: 0,
      content: "",
      content_validate: false,
      sortDesc: false,
      search: null,
      menu_date_start: null,
      menu_date_end: null,
      temp_date: '',
      news_data: [],
      values_items: [],
      values_select: null,
      save_news: {
        date_start: null,
        date_end: null,
      },
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      rules: {
        is_empty: val => (val || 0).length > 0 || 'ต้องระบุข้อมูลในช่องนี้'
      },
      date_now: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString(),
    }
  },
  methods: {

    save_data() {
      this.content_validate = this.content == '' ? true : false;

      if (this.$refs.news_add_pos_save.validate()) {
        if (this.content == '') {
          return;
        }
        let data = {
          content: {
            admin_id: this.$store.state.userDetail.id,
            title: this.news_title,
            content: this.content,
            notify_date_start: this.save_news.date_start,
            notify_date_stop: this.save_news.date_end,
            all_customer_notify: this.title_type
          }
        };

        if (this.title_type == 1) {
          data = {
            ...data,
            customer_code:
              this.values_select

          }
        }

        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };

        this.is_submit = true;
        HTTP_ARIN.post("/news/createnews", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              this.alert_success = true
              setTimeout(() => { this.alert_success = false, this.$router.push('/newsinformation') }, 2000)
            } else {
              this.is_submit = false;
            }

          }
        );
      }
    },
    async getStoredetail() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/news/getstoredetail", config).then((res) => {
        if (res.data.successful === true) {
          this.values_items = res.data.storeList;
        }
      });
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    get_detail() {
      this.$router.push('')
    },
    minDate() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      const result_date = today.getFullYear() + '-' + month + '-' + date;
      return result_date;
    },
    diffDateTH_start(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]

      // พศ
      // const year = parseInt(diff[0]) + 543
      // const final_date = day + '-' + month + '-' + year

      // คศ
      const year = parseInt(diff[0])
      const final_date = year + '-' + month + '-' + day
      return this.save_news.date_start = final_date
    },
    diffDateTH_end(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]

      // พศ
      // const year = parseInt(diff[0]) + 543
      // const final_date = day + '-' + month + '-' + year

      // คศ
      const year = parseInt(diff[0])
      const final_date = year + '-' + month + '-' + day
      return this.save_news.date_end = final_date
    },


  },
  mounted() {
    // this.page(0)
    this.getStoredetail()
  },
  watch: {
    content() {
      this.content_validate = this.content == '' ? true : false;
    }
  }
}
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.color-grey {
  color: #909090;
}
</style>
